import { FC, useEffect } from "react";
import { useAppDispatch } from "../../../custom-hooks/useAppDispatch";
import { WorkServiceImpl } from "../../../services/WorkServiceImpl";
import { DEFAULT_PAGE, RECORDS_PER_SLIDER } from "../../../domain/constants";
import { SortingOrder } from "../../../domain/enums/common/SortingOrderEnum";
import { useSelector } from "react-redux";
import { selectWorks } from "../../../slices/works-slice";
import { useTranslation } from "react-i18next";
import MainPageSlider from "./MainPageSlider";
import WorkCard from "../../resources/components/work-components/work-list/WorkCard";
import { WorkListType } from "../../../domain/models/Work";
import { getUserCoords, selectUser } from "../../../slices/user-slice";

const CurrentVacanciesSection: FC = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const works = useSelector(selectWorks);
    const user = useSelector(selectUser());

    useEffect(() => {
        (async () =>
            await dispatch(
                WorkServiceImpl.getWorksThunk({
                    page: DEFAULT_PAGE,
                    limit: RECORDS_PER_SLIDER,
                    form: {
                        title: null,
                        showOnlyActive: true,
                        price: SortingOrder.DESC,
                        distance: SortingOrder.ASC,
                        startFrom: SortingOrder.ASC,
                    },
                    coords: await getUserCoords(user),
                })
            ))();
    }, []);

    if (!works.rows?.length) {
        return <></>;
    }

    return (
        <div className="relative dmin7:mx-auto flex flex-col justify-center mt-[100px] dmax2:mt-[60px] dmax7:w-[calc(100vw-10px)] dmin7:w-[1910px]">
            <h1 className="H32B dmax2:H24B text-textWhite text-center mb-10 dmax2:mb-6">
                {t("main.currentVacancies")}
            </h1>
            <MainPageSlider
                entities={works.rows}
                mapCallback={(work) => (
                    <WorkCard
                        key={`main-page-slide-${work.id}`}
                        work={work}
                        className="mr-7 di6:mr-5 ti6:mr-4 tmax5:mr-2"
                        type={WorkListType.COMMON}
                    />
                )}
            />
        </div>
    );
};

export default CurrentVacanciesSection;
